// TODO: Remove in Babel 8

export {
  default,
  isBrowsersQueryValid,
} from "@babel/helper-compilation-targets";
